var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
var PrintTail = (function (_super) {
    __extends(PrintTail, _super);
    function PrintTail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrintTail.prototype.mounted = function () {
        if (this.configModel.template_type === 19) {
            this.initializeCheckboxes();
        }
    };
    PrintTail.prototype.initializeCheckboxes = function () {
        if (!this.configModel.table_footer.signature) {
            return;
        }
        var signature = this.configModel.table_footer.signature;
        if (!this.configModel.table_footer.hasOwnProperty('is_show_auditor')) {
            this.$set(this.configModel.table_footer, 'is_show_auditor', signature.includes('确认人：{确认人}') ? '1' : '0');
        }
        if (!this.configModel.table_footer.hasOwnProperty('is_show_creator')) {
            this.$set(this.configModel.table_footer, 'is_show_creator', signature.includes('制单人：{制单人}') ? '1' : '0');
        }
    };
    PrintTail.prototype.handleAuditorChange = function (newVal) {
        if (newVal === '1') {
            if (!this.configModel.table_footer.signature.includes('确认人：{确认人}')) {
                this.configModel.table_footer.signature += '确认人：{确认人}';
            }
        }
        else {
            this.configModel.table_footer.signature = this.configModel.table_footer.signature.replace('确认人：{确认人}', '');
        }
    };
    PrintTail.prototype.handleCreatorChange = function (newVal) {
        if (newVal === '1') {
            if (!this.configModel.table_footer.signature.includes('制单人：{制单人}')) {
                this.configModel.table_footer.signature += '制单人：{制单人}';
            }
        }
        else {
            this.configModel.table_footer.signature = this.configModel.table_footer.signature.replace('制单人：{制单人}', '');
        }
    };
    PrintTail.prototype.addReturnStore = function () {
        if (this.readonly) {
            return;
        }
        var signature = this.configModel.table_footer.signature || '';
        var returnStoreText = '退货门店:{退货门店}';
        if (signature.includes(returnStoreText)) {
            this.$message.warning('不可重复添加退货门店字段');
            return;
        }
        this.configModel.table_footer.signature = signature + returnStoreText;
    };
    __decorate([
        Prop({
            type: Object
        })
    ], PrintTail.prototype, "configModel", void 0);
    __decorate([
        Prop({
            type: Array
        })
    ], PrintTail.prototype, "fontSizeList", void 0);
    __decorate([
        Prop({
            type: Boolean
        })
    ], PrintTail.prototype, "readonly", void 0);
    PrintTail = __decorate([
        Component({
            watch: {
                'configModel.table_footer.is_show_auditor': function (newVal, oldVal) {
                    if (this.configModel.template_type === 19) {
                        this.handleAuditorChange(newVal);
                    }
                },
                'configModel.table_footer.is_show_creator': function (newVal, oldVal) {
                    if (this.configModel.template_type === 19) {
                        this.handleCreatorChange(newVal);
                    }
                }
            }
        })
    ], PrintTail);
    return PrintTail;
}(Vue));
export default PrintTail;
